import request from 'sb-request'
import constants from 'common/helpers/constants'


const getCount = ({ gender, brands, tags, notes, rating, visibility }) =>
  request.get('rest/shop/count/filter', {
    query: {
      gender,
      filter: {
        brands,
        tags,
        notes,
        rating,
        visibility,
      },
    },
  })
    .then(({ count }) => count)

/**
 * @param filters
 * @param {string} filters.gender
 * @param {string} filters.category
 * @param {string[]} filters.brands
 * @param {string[]} filters.notes
 * @param {string[]} filters.tags
 * @param {Number} filters.rating
 * @param {string} filters.sort
 * @param {string} filters.visibility
 */
const fetch = (filters = {}) => {
  let { gender, category, groups, brands, notes, tags, rating, visibility, sort, types } = filters
  let productsFeed

  // categories mapped to product feed
  if (category === 'all') {
    productsFeed = constants.productsFeed.allPerfumes
  }
  else if (category === 'bestsellers') {
    productsFeed = constants.productsFeed.bestsellers
  }
  else if (category === 'newarrivals') {
    productsFeed = constants.productsFeed.newArrivals
  }
  else if (category === 'niche') {
    productsFeed = constants.productsFeed.niche
  }

  // we show sorted fragrances with 4-5 rating for top rated category
  if (category === 'toprated') {
    rating = 4
    sort = 'reviews_rating'
    category = null
  }

  // sort by rating by default if rating filter is active
  if (rating && !sort) {
    sort = 'reviews_rating'
  }

  // TODO rework models/fragrances - this should be module to resolve products of all types
  // this is fix for urls like /subscription/brand/kopari coz there are no items for group [ "Perfume" ]
  // fetch products of all types by passing [] in filters.groups
  const _groups = groups && Array.isArray(groups) ? JSON.stringify(groups) : '[ "Perfume" ]'

  let params = `groups: ${_groups}`

  if (gender) {
    params += `, gender: "${gender}"`
  }

  if (category && category !== 'all') {
    // KOSTYL`!!!!
    // for bestsellers-all we should fetch all bestsellers from groups: HomeFragrance, Perfumes, Makeup, BathBody
    if (category === 'bestsellers-all') {
      params = 'groups: [ "HomeFragrance", "Perfume", "Makeup", "BathBody" ]'
      params += ', category: "bestsellers"'
    }
    else {
      params += `, category: "${category}"`
    }
  }
  else {
    if (brands && brands.length) {
      params += `, brands: ${JSON.stringify(brands)}`
    }

    if (notes && notes.length) {
      params += `, notes: ${JSON.stringify(notes)}`
    }

    if (tags && tags.length) {
      params += `, tags: ${JSON.stringify(tags)}`
    }

    if (visibility) {
      params += `, visibility: "${visibility}"`
    }

    if (types) {
      params += `, types: ${JSON.stringify(types)}`
    }
  }

  if (productsFeed) {
    params += `, productsFeed: "${productsFeed}"`
  }

  if (sort) {
    params += `, sort: "${sort}"`
  }

  if (rating) {
    params += `, rating: ${rating}`
  }

  return request.post('graphql?name=products', {
    body: {
      query: `{
        items: products(${params}) {
          id
          url
          img
          name
          type
          brand
          rating
          labels
          category
          upchargePrice
          tradingItem {
            id
          }
        }
      }`,
    },
    modifyResult: ({ items = [] }) => items.map(({ tradingItem, ...item }) => ({
      ...item,
      tradingId: tradingItem && tradingItem.id, // it should be `tradingItem && tradingItem.id` coz there is `tradingItem: null` in response
    })),
  })
}


export default {
  fetch,
  getCount,
}
